import { render, staticRenderFns } from "./PlanUnit.vue?vue&type=template&id=4c2a4436&"
import script from "./PlanUnit.vue?vue&type=script&lang=js&"
export * from "./PlanUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\Jatin\\Documents\\Source\\wiom-dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2a4436')) {
      api.createRecord('4c2a4436', component.options)
    } else {
      api.reload('4c2a4436', component.options)
    }
    module.hot.accept("./PlanUnit.vue?vue&type=template&id=4c2a4436&", function () {
      api.rerender('4c2a4436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/plans/PlanUnit.vue"
export default component.exports